import React from 'react';
import { useReactivateTempBadgeMutation } from 'apollo/generated/client-operations';
import { getGraphQLError } from 'utils/error';
import { AlertService } from 'components/alertService/AlertService';
import { FormOnSubmit, ModalFormContent } from 'components/form';
import { RedoIcon } from 'components/icons';
import { TempBadge } from 'containers/jobsite/tabs/jobsiteTempBadges/types';
import { useIsMounted } from 'utils';
import { StaticTempBadgePreview } from 'containers/jobsite/tabs/jobsiteTempBadges/components';

export function ReactivateTempBadgeModalContent(props: {
  closeModal: () => void;
  onAction: (tempBadge: TempBadge) => void;
  tempBadge: TempBadge;
  jobsiteName: string;
}): React.ReactElement {
  const { closeModal, onAction, tempBadge, jobsiteName } = props;
  const [isFetching, setIsFetching] = React.useState<boolean>(false);
  const isMounted = useIsMounted();

  const [reactivateTempBadge, { loading }] = useReactivateTempBadgeMutation();

  const onSubmit: FormOnSubmit<unknown> = async (
    _data,
    event,
  ): Promise<void> => {
    if (isFetching) return;
    setIsFetching(true);

    try {
      const { data: result } = await reactivateTempBadge({
        variables: { id: tempBadge.id },
      });
      const reactivatedTempBadge = result.reactivateTempBadge.tempBadge;
      onAction(reactivatedTempBadge);
      AlertService.alert(
        'success',
        'Success',
        'Temporary badge successfully reactivated',
      );
    } catch (error) {
      event.preventDefault();
      AlertService.alert(
        'danger',
        'Error when reactivating temporary badge',
        getGraphQLError(error),
      );
    } finally {
      if (isMounted()) setIsFetching(false);
    }
  };

  return (
    <ModalFormContent
      setOpen={closeModal}
      renderAbove={
        <div>
          <div className="odin-flex odin-justify-center odin-mb-4">
            <StaticTempBadgePreview
              templateName={tempBadge.badgeTemplate?.templateName}
              badgeName={tempBadge.name}
              jobsiteName={jobsiteName}
            />
          </div>
          <p className="odin-text-center">
            Would you like to reactivate this temporary badge?
          </p>
        </div>
      }
      inputs={null}
      onSubmit={onSubmit}
      actionText="Reactivate"
      actionIcon={RedoIcon}
      actionButtonWithSpinner={loading}
    />
  );
}
